import { addMessageCurry, commonActionAPIHit } from '../utils/api'
import { SET_SETTINGS, SET_CREDENTIAL, SET_DRIVERS_BY_SHOP } from '../types/dispatch'
import {
  getWorkerByProviderAPI,
  createWorkerOnDispatchAPI,
  getDCHEmployeesByCompanyAPI,
  getDCHEmployeesByCompanyIdAndShopIdAPI,
  syncWorkerOnDispatchAPI,
  removeWorkerOnDispatchAPI,
  deleteEmployeeOnDispatchAPI,
  getDriversByAssignedShopAPI,
  getDCHSettingsByCompanyIdAPI,
  getDCHSettingsByCompanyIdAndShopIdsAPI,
  createDCHSettingsAPI,
  updateDCHSettingsAPI,
  deleteDCHSettingsAPI,
  createInternalWorkerOnDispatchAPI,
  getDCHCredentialByShopIdAPI,
  updateDCHCredentialsAPI,
  createDCHCredentialsAPI,
  checkDCHApiKeyAPI,
  getDCHRenewTokenAPI,
} from '../api/dispatch'

export const setSettings = (payload) => ({
  type: SET_SETTINGS,
  payload,
})

export const setWmDispatchCretendial = (payload) => ({
  type: SET_CREDENTIAL,
  payload,
})

export const setDriversByShop = (payload) => ({
  type: SET_DRIVERS_BY_SHOP,
  payload,
})

export const getWorkerByProvider = commonActionAPIHit(getWorkerByProviderAPI)
export const createWorkerOnDispatch = commonActionAPIHit(createWorkerOnDispatchAPI)
export const createInternalWorkerOnDispatch = commonActionAPIHit(createInternalWorkerOnDispatchAPI)
export const getDCHEmployeesByCompany = commonActionAPIHit(getDCHEmployeesByCompanyAPI)
export const getDCHEmployeesByCompanyIdAndShopId = commonActionAPIHit(
  getDCHEmployeesByCompanyIdAndShopIdAPI,
)
export const syncWorkerOnDispatch = commonActionAPIHit(syncWorkerOnDispatchAPI)
export const removeWorkerOnDispatch = commonActionAPIHit(removeWorkerOnDispatchAPI)
export const deleteEmployeeOnDispatch = commonActionAPIHit(deleteEmployeeOnDispatchAPI)

export const getDriversByAssignedShop = (shopId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDriversByAssignedShopAPI(shopId), dispatch)
        .then((driverList) => {
          dispatch(setDriversByShop(driverList))
          resolve(driverList)
        })
        .catch((err) => console.log(err))
    })
  }
}

//Settings
export const getDCHSettingsByCompanyId = (companyId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDCHSettingsByCompanyIdAPI(companyId), dispatch)
        .then((settingsList) => {
          dispatch(setSettings({ settingsList }))
          resolve(settingsList)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const getDCHSettingsByCompanyIdAndShopIds = (request) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDCHSettingsByCompanyIdAndShopIdsAPI(request), dispatch)
        .then((settingsList) => {
          dispatch(setSettings({ settingsList }))
          resolve(settingsList)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const createDCHSettings = commonActionAPIHit(createDCHSettingsAPI)
export const updateDCHSettings = commonActionAPIHit(updateDCHSettingsAPI)
export const deleteDCHSettings = commonActionAPIHit(deleteDCHSettingsAPI)

//Credentials

export const getDCHCredentialByShopId = ({ companyId, shopId, provider }) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getDCHCredentialByShopIdAPI({ companyId, shopId, provider }), dispatch)
        .then((credential) => {
          dispatch(setWmDispatchCretendial(credential))
          resolve(credential)
        })
        .catch((err) => console.log(err))
    })
  }
}

export const updateDCHCredentials = commonActionAPIHit(updateDCHCredentialsAPI)
export const createDCHCredentials = commonActionAPIHit(createDCHCredentialsAPI)
export const checkDCHApiKey = commonActionAPIHit(checkDCHApiKeyAPI)
export const getDCHRenewToken = commonActionAPIHit(getDCHRenewTokenAPI)



// WEBPACK FOOTER //
// ./src/actions/dispatch.js